import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

// Your web app's Firebase configuration
const fbConfig = {
  apiKey: "AIzaSyBj01G1U8p8LlKVzZsQV5pM5hBUcE74Agk",
  authDomain: "diet-matador.firebaseapp.com",
  databaseURL: "https://diet-matador.firebaseio.com",
  projectId: "diet-matador",
  storageBucket: "diet-matador.appspot.com",
  messagingSenderId: "1086773120236",
  appId: "1:1086773120236:web:07b55064c61e58d939e9c9",
  measurementId: "G-T10Y37WS4S",
  userProfile: 'users',
  useFirestoreForProfile: true
};

firebase.initializeApp(fbConfig);
// firebase.analytics();
// firebase.firestore().settings({ })

export default firebase;